export const countries = {
  gp: {
    description:
      "La isla mariposa que ofrece una rica cultura criolla y el volcán de la Soufrière.",
    landmarks: [
      "Volcán de la Soufrière",
      "Playa Grande Anse",
      "Cataratas del Carbet",
    ],
    gastronomy:
      "Buñuelos de bacalao, colombo de pollo, pastel tourment d'amour.",
  },
  mq: {
    description:
      "La fascinante Isla de las Flores, conocida por el Monte Pelée y el ron.",
    landmarks: ["Monte Pelée", "Jardín de Balata", "Roca del Diamante"],
    gastronomy: "Pollo ahumado, morcilla criolla, blanc-manger de coco.",
  },
  gf: {
    description:
      "La puerta europea al espacio y un santuario de gran biodiversidad amazónica.",
    landmarks: [
      "Centro Espacial Guayanés",
      "Islas de la Salvación",
      "Marismas de Kaw",
    ],
    gastronomy: "Caldo de awara, fricasé de caza, pollo asado criollo.",
  },
  re: {
    description:
      "Una joya volcánica del océano Índico que une lagunas turquesas y picos escarpados.",
    landmarks: ["Piton de la Fournaise", "Circo de Mafate", "Piton des Neiges"],
    gastronomy: "Rougail de salchicha, curry de pollo, samosas.",
  },
  yt: {
    description:
      "La isla del perfume rodeada de una inmensa laguna que alberga majestuosas tortugas marinas.",
    landmarks: ["Laguna de Mayotte", "Monte Choungui", "Playa N'Gouja"],
    gastronomy:
      "Brochetas de cebú (mtsolola), mataba (hojas de mandioca), arroz pilao.",
  },
  pf: {
    description:
      "El paraíso terrenal del Pacífico, salpicado de cabañas sobre el agua y arrecifes de coral.",
    landmarks: ["Laguna de Bora Bora", "Monte Otemanu", "Bahía de Cook"],
    gastronomy: "Pescado crudo en leche de coco, fafaru, postre poe.",
  },
  nc: {
    description:
      "Tierra de contrastes, con la laguna cerrada más grande del mundo y la cultura Kanak.",
    landmarks: ["Faro Amédée", "Corazón de Voh", "Bahía de Oro"],
    gastronomy: "Bougna tradicional, ensalada de ciervo, ceviche.",
  },
  ic: {
    description:
      "Un archipiélago de primavera eterna, esculpido por paisajes volcánicos lunares.",
    landmarks: [
      "Parque Nacional del Teide",
      "Dunas de Maspalomas",
      "Parque Nacional de Timanfaya",
    ],
    gastronomy: "Papas arrugadas, mojo verde/rojo, sancocho.",
  },
  ptm: {
    description:
      "La isla que cae dramáticamente hacia el Atlántico, brillante por sus increíbles viñedos.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "Las Levadas"],
    gastronomy: "Espetada (brochetas de carne), pan bolo do caco, pez sable.",
  },
  pta: {
    description:
      "Santuario oceánico virgen donde los cráteres volcánicos forman impresionantes lagos gemelos.",
    landmarks: [
      "Lagos Gemelos Sete Cidades",
      "Monte Pico",
      "Aguas Termales de Furnas",
    ],
    gastronomy: "Cozido das Furnas (estofado volcánico), queso de São Jorge.",
  },
  aw: {
    description:
      "Los refrescantes vientos alisios barren interminables playas de arena blanca en esta isla.",
    landmarks: ["Parque Nacional Arikok", "Eagle Beach", "Faro California"],
    gastronomy:
      "Keshi Yena (queso relleno), empanadas pastechi, guiso de cabra.",
  },
  cw: {
    description:
      "Famosa por sus calas escondidas de aguas cristalinas y arquitectura colonial holandesa.",
    landmarks: [
      "Puente Flotante Reina Emma",
      "Playa Porto Mari",
      "Parque Christoffel",
    ],
    gastronomy: "Estofado de carne Karni Stoba, tortitas de calabaza.",
  },
  sx: {
    description:
      "The Friendly Island, su espectacular escena de aviones rosando la playa es fascinante.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "Costillas a la BBQ, pan journey cakes, cangrejo relleno.",
  },
  bm: {
    description:
      "Un mítico archipiélago elegante conocido por sus misteriosas playas de arena rosa.",
    landmarks: ["Horseshoe Bay Beach", "Cuevas de Cristal", "Faro Gibbs Hill"],
    gastronomy: "Sopa de pescado de las Bermudas (con ron), hoppin' john.",
  },
  ky: {
    description:
      "El paraíso mundial del buceo ofreciendo encuentros espectaculares con rayas.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Jardín Botánico"],
    gastronomy:
      "Ternera estilo Caimán, buñuelos de caracol, pastel de mandioca.",
  },

  fr: {
    description:
      "Francia es el principal destino turístico del mundo, reconocida por su excepcional patrimonio, diversos paisajes que van desde la Riviera francesa hasta los picos alpinos y un incomparable arte de vivir.",
    gastronomy: "Baguette, quesos, vino, croissants, ternera bourguignon.",
    landmarks: [
      "Torre Eiffel, París",
      "Monte Saint-Michel",
      "Castillos del Valle del Loira",
      "Riviera Francesa",
    ],
    overseas: [
      "Guadalupe",
      "Martinica",
      "Guayana Francesa",
      "Reunión",
      "Mayotte",
      "Polinesia Francesa",
      "Nueva Caledonia",
    ],
  },
  es: {
    description:
      "España fascina con su clima soleado, su vibrante cultura, desde las siestas hasta el flamenco, sus magníficas playas y su arquitectura histórica única, especialmente su herencia árabe.",
    gastronomy: "Tapas, paella, jamón ibérico, gazpacho, sangría.",
    landmarks: [
      "Sagrada Familia, Barcelona",
      "Alhambra, Granada",
      "Palacio Real de Madrid",
      "Plaza de España, Sevilla",
    ],
    overseas: ["Canarias", "Islas Baleares", "Ceuta", "Melilla"],
  },
  it: {
    description:
      "Italia es un museo al aire libre. Entre ruinas romanas, el Renacimiento florentino, canales venecianos y una costa pintoresca, el país ofrece un viaje inolvidable.",
    gastronomy: "Pasta, pizza, helado, espresso, tiramisú.",
    landmarks: [
      "Coliseo, Roma",
      "Torre inclinada de Pisa",
      "Catedral de Florencia",
      "Gran Canal, Venecia",
    ],
    overseas: ["Cerdeña"],
  },
  de: {
    description:
      "Alemania combina la modernidad urbana con el romance de sus castillos y la Selva Negra. Conocido por su dinamismo y rica historia.",
    gastronomy: "Bratwurst, pretzel, chucrut, cerveza.",
    landmarks: [
      "Puerta de Brandenburgo, Berlín",
      "Castillo de Neuschwanstein",
      "Catedral de Colonia",
      "Marienplatz, Múnich",
    ],
  },
  gb: {
    description:
      "El Reino Unido ofrece una mezcla única de tradición monárquica, vanguardia cultural, impresionantes paisajes escoceses y ciudades históricas.",
    gastronomy: "Fish and chips, rosbif, pudín de Yorkshire, té.",
    landmarks: [
      "Big Ben y Palacio de Westminster",
      "Stonehenge",
      "Torre de Londres",
      "Castillo de Edimburgo",
    ],
    overseas: ["islas Bermudas", "Islas Caimán", "Gibraltar"],
  },
  pt: {
    description:
      "Portugal encanta con sus coloridas calles, sus playas bañadas por el Atlántico y la excepcional hospitalidad de su gente, al son de la inquietante melodía del fado.",
    gastronomy: "Pastéis de nata, bacalhau, francesinha, vino de Oporto.",
    landmarks: [
      "Torre de Belém, Lisboa",
      "Ribeira, Oporto",
      "Palacio de la Pena, Sintra",
      "playas del algarve",
    ],
    overseas: ["Madeira", "Azores"],
  },
  gr: {
    description:
      "Cuna de la civilización occidental, Grecia le invita a un viaje mitológico, desde la Acrópolis hasta las sublimes aguas cristalinas de las islas Cícladas.",
    gastronomy: "Moussaka, souvlaki, ensalada griega, tzatziki.",
    landmarks: [
      "Acrópolis de Atenas",
      "Santorini",
      "Meteora",
      "Palacio de Knossos",
    ],
    overseas: ["Creta", "Rodas"],
  },
  ch: {
    description:
      "Suiza es un paraíso alpino que ofrece lagos de un azul profundo, fortalezas medievales y montañas asombrosas, perfecto tanto para los amantes de la naturaleza como de la comodidad.",
    gastronomy: "Fondue de queso, raclette, chocolate suizo, rösti.",
    landmarks: [
      "Matterhorn",
      "Lago Lemán",
      "Castillo de Chillón",
      "Jungfraujoch",
    ],
  },
  nl: {
    description:
      "Los Países Bajos son famosos por sus paisajes llanos, canales laberínticos, campos de tulipanes y molinos de viento icónicos.",
    gastronomy: "Gouda, stroopwafel, arenque crudo, poffertjes.",
    landmarks: [
      "Canales de Ámsterdam",
      "Molinos de viento de Kinderdijk",
      "Museo Van Gogh",
    ],
    overseas: ["Aruba", "Curazao", "San Martín"],
  },
  be: {
    description:
      "En el corazón de Europa, Bélgica es mundialmente conocida por sus encantadoras ciudades medievales, la diplomacia europea, su chocolate y su cerveza.",
    gastronomy:
      "Gofres, patatas fritas, mejillones, pralinés, cervezas trapenses.",
    landmarks: [
      "Gran Plaza de Bruselas",
      "Campanario de Brujas",
      "átomo",
      "Castillo de Gravensteen",
    ],
  },
  bg: {
    description:
      "Bulgaria es un mosaico balcánico que combina costas doradas del Mar Negro, terrenos montañosos y una increíble herencia tracia.",
    gastronomy: "Banitsa, ensalada Shopska, tarator, moussaka búlgara.",
    landmarks: [
      "Monasterio de Rila",
      "Catedral de Alejandro Nevski",
      "playa soleada",
    ],
  },
  dk: {
    description:
      "Dinamarca representa el concepto 'Hygge': un país nórdico pacífico, pionero en diseño, lleno de carriles bici y palacios reales.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, cerveza Carlsberg.",
    landmarks: ["Nyhavn", "La Sirenita", "Castillo de Kronborg"],
    overseas: ["Islas Feroe", "Tierra Verde"],
  },
  hr: {
    description:
      "Croacia ofrece más de mil islas a lo largo del mar Adriático, salpicadas de joyas arquitectónicas romanas y exuberantes parques nacionales.",
    gastronomy: "Ćevapi, ensalada de pulpo, peka, quesos de la isla de Pag.",
    landmarks: [
      "Murallas de Dubrovnik",
      "Parque Nacional de los Lagos de Plitvice",
      "Palacio de Diocleciano",
    ],
  },
  cy: {
    description:
      "Chipre es una isla legendaria del Mediterráneo, el lugar de nacimiento de Afrodita, que combina playas vírgenes con impresionantes ruinas antiguas.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Parque Arqueológico de Pafos",
      "La roca de Afrodita",
      "Montañas de Troodos",
    ],
  },
  cz: {
    description:
      "Chequia fascina con sus ciudades con cien chapiteles, cervecerías centenarias y castillos de cuento de hadas en el corazón de Europa Central.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Puente de Carlos, Praga",
      "Castillo de Praga",
      "Osario de Sedlec",
      "Karlovy Vary",
    ],
  },
  ee: {
    description:
      "Estonia es una nación pionera digital que alberga vastos bosques primitivos y una capital medieval intacta frente al Báltico.",
    gastronomy:
      "Verivorst (morcilla), pan negro, espadines, cerveza artesanal.",
    landmarks: [
      "Casco antiguo de Tallin",
      "Parque Nacional Lahemaa",
      "Castillo de Hermann",
    ],
  },
  fi: {
    description:
      "Finlandia, el país de los mil lagos, es famoso por su resplandeciente naturaleza salvaje, la aurora boreal en Laponia y su vital cultura de la sauna.",
    gastronomy:
      "Salmón ahumado, carne de reno, pan de centeno, empanadas de Carelia.",
    landmarks: [
      "Suomenlinna",
      "Pueblo de Papá Noel",
      "Parque Nacional Nuuksio",
    ],
  },
  hu: {
    description:
      "Hungría está bellamente dividida en dos por el Danubio, repleto de espectaculares baños termales, viñedos históricos y el majestuoso parlamento.",
    gastronomy: "Goulash, Lángos, Pollo Paprikash, Vino Tokaji.",
    landmarks: [
      "Parlamento de Budapest",
      "Baños termales Széchenyi",
      "Castillo de Buda",
      "Lago Balatón",
    ],
  },
  ie: {
    description:
      "Irlanda, la Isla Esmeralda, se define por sus acantilados azotados por el viento, su cálida música celta y su acogedora cultura de pub.",
    gastronomy: "Estofado irlandés, Guinness, pan de soda, colcannon.",
    landmarks: [
      "Acantilados de Moher",
      "Almacén de Guinness",
      "Anillo de Kerry",
      "Colegio Trinidad",
    ],
  },
  lv: {
    description:
      "Letonia encanta con su bulliciosa capital llena de arquitectura Art Nouveau y kilómetros de playas vírgenes en la costa báltica.",
    gastronomy:
      "Rupjmaize (pan oscuro de centeno), guisantes grises con tocino, espadines.",
    landmarks: [
      "Casco antiguo de Riga",
      "Casa de las Cabezas Negras",
      "Parque Nacional Gauja",
    ],
  },
  lt: {
    description:
      "Lituania es la joya más meridional del Báltico, rica en lagos glaciares, densos bosques y conmovedores testimonios de su tumultuoso pasado.",
    gastronomy:
      "Cepelinai (albóndigas de patata), sopa fría de borscht (šaltibarščiai).",
    landmarks: [
      "Castillo de la isla de Trakai",
      "Cerro de las Cruces",
      "Casco antiguo de Vilna",
    ],
  },
  lu: {
    description:
      "Luxemburgo es un próspero microestado gran ducal, cuyos valles rebosan de castillos medievales y su capital es una espectacular ciudadela.",
    gastronomy: "Judd mat Gaardebounen, Gromperekichelcher, vinos del Mosela.",
    landmarks: [
      "Camino de la Corniche",
      "Casamatas de Bock",
      "Castillo de Vianden",
    ],
  },
  mt: {
    description:
      "Malta combina a la perfección la calidez del sol mediterráneo y 7.000 años de historia naval, fortalezas templarias y lagunas turquesas.",
    gastronomy: "Pastizzi, guiso de conejo (Stuffat tal-fenek), ftira.",
    landmarks: [
      "Concatedral de San Juan",
      "ciudad de mdina",
      "Laguna Azul (Comino)",
    ],
  },
  pl: {
    description:
      "Polonia es el pilar cultural de Europa del Este, dotada de imponentes ciudades restauradas, el trágico monumento a Auschwitz y las montañas Tatra.",
    gastronomy: "Pierogi, bigos, kielbasa, vodka polaco.",
    landmarks: [
      "Plaza del Mercado de Cracovia",
      "Mina de sal de Wieliczka",
      "Auschwitz-Birkenau",
      "Castillo de Wawel",
    ],
  },
  ro: {
    description:
      "Dominada por la leyenda de Drácula, Rumania alberga las suntuosas montañas de los Cárpatos, el majestuoso delta del Danubio y las vibrantes ciudades de Transilvania.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Castillo de Bran",
      "Castillo Peleș",
      "Delta del Danubio",
      "Palacio del Parlamento",
    ],
  },
  sk: {
    description:
      "Menos conocida, Eslovaquia es un tesoro montañoso con el mayor número de castillos per cápita del mundo, dentro de los Altos Tatras.",
    gastronomy: "Bryndzové halušky (ñoquis de queso de oveja), Kofola.",
    landmarks: ["Castillo de Bratislava", "Altos Tatras", "Castillo de Spiš"],
  },
  si: {
    description:
      "Eslovenia es un pequeño paraíso ecológico que alberga el mítico lago Bled, colosales cuevas kársticas y una capital excepcionalmente verde.",
    gastronomy: "Kranjska klobasa, potica (rollo de nueces), štrukli.",
    landmarks: [
      "Lago Bled",
      "Cueva de Postoina",
      "Castillo de Liubliana",
      "Parque Nacional Triglav",
    ],
  },
  se: {
    description:
      "Suecia encarna el estilo escandinavo, repartido entre magníficos archipiélagos, auroras boreales y una rica tradición de diseño elegante.",
    gastronomy:
      "Albóndigas (Köttbullar), fika, salmón gravlax, arenque surströmming.",
    landmarks: [
      "Museo Vasa",
      "Ciudad de Visby",
      "Gamla Stan",
      "Hotel de hielo Jukkasjärvi",
    ],
  },
  is: {
    description:
      "Islandia, la tierra del fuego y el hielo, sorprende con sus géiseres, glaciares titánicos, volcanes activos y aguas termales lechosas.",
    gastronomy: "Hákarl (tiburón fermentado), Skyr, cordero islandés.",
    landmarks: [
      "Laguna Azul",
      "Círculo Dorado",
      "Cascada de Gullfoss",
      "Playa de arena negra de Reynisfjara",
    ],
  },
  no: {
    description:
      "Noruega ofrece uno de los escenarios geológicos más bellos del mundo: sus majestuosos fiordos abisales tallan el mar rodeados de escarpadas montañas.",
    gastronomy: "Salmón, rakfisk, queso moreno (Brunost), carne de alce.",
    landmarks: [
      "Fiordo de Geiranger",
      "Cabo Norte",
      "Islas Lofoten",
      "Bryggen",
    ],
  },
  al: {
    description:
      "Albania, antiguamente hermética, es la joya secreta del Mediterráneo rebosante de aguas cristalinas, Alpes espectaculares y ruinas grecorromanas.",
    gastronomy: "Byrek, fëgesë, mariscos, baklava.",
    landmarks: ["Riviera albanesa", "berat", "Parque Nacional de Butrinto"],
  },
  ad: {
    description:
      "Ubicado en lo alto de los Pirineos, este pequeño principado es un verdadero santuario para los amantes del esquí y la naturaleza salvaje.",
    gastronomy: "Trinxat, escudella, charcutería de montaña.",
    landmarks: ["Valle del Madriu-Perafita-Claror", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "Un país alpino por excelencia, Austria brilla con su incomparable música clásica, palacios imperiales e impresionantes paisajes alpinos.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: [
      "Palacio de Schönbrunn",
      "Palacio Hofburg",
      "Alpes de Kitzbühel",
    ],
  },
  mc: {
    description:
      "Mónaco es el epítome del glamour a orillas del Mediterráneo, con yates de lujo, su casino de fama mundial y el legendario Gran Premio de Fórmula 1.",
    gastronomy: "Barbajuan, fougasse monegasca, stocafi.",
    landmarks: [
      "Casino de Montecarlo",
      "La Roca de Mónaco",
      "Palacio del Príncipe",
      "Puerto Hércules",
    ],
  },
  am: {
    description:
      "Armenia, una de las naciones cristianas más antiguas del mundo, ofrece espectaculares paisajes montañosos y majestuosos monasterios de piedra ubicados al borde de profundos cañones.",
    gastronomy: "Khorovats (barbacoa armenia), dolma, lavash, lahmajoun.",
    landmarks: [
      "Monasterio de Khor Virap",
      "Templo de Garni",
      "Monasterio de Geghard",
    ],
  },
  az: {
    description:
      'Azerbaiyán, la "Tierra del Fuego", es una fascinante combinación de antiguo patrimonio histórico y reluciente infraestructura ultramoderna a orillas del Mar Caspio.',
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Torres de llamas (Bakú)",
      "Ciudad Vieja (Icherisheher)",
      "Volcanes de lodo de Gobustán",
    ],
  },
  by: {
    description:
      "Bielorrusia sorprende por su naturaleza preservada, sus densos bosques vírgenes (como el de Bialowieza), hogar de bisontes y sus castillos medievales con un rico pasado.",
    gastronomy: "Draniki (tortitas de patata), machanka, kolduny.",
    landmarks: ["Castillo Mir", "Palacio Nesvizh", "Fortaleza de Brest"],
  },
  ba: {
    description:
      "Un cruce de culturas en el corazón de los Balcanes, donde Oriente se encuentra con Occidente. Te enamorarás de los ríos esmeralda, las escarpadas montañas y el famoso Puente Viejo de Mostar.",
    gastronomy: "Ćevapi, burek, baklava, café bosnio.",
    landmarks: [
      "Stari Most (Puente Viejo)",
      "Baščaršija (Sarajevo)",
      "Cascadas de Kravica",
    ],
  },
  ge: {
    description:
      "Georgia ofrece una naturaleza grandiosa en las montañas del Cáucaso, una arquitectura antigua fascinante y la reputación de ser la región vitivinícola más antigua del mundo.",
    gastronomy: "Khachapuri, khinkali (empanadillas), churchkhela.",
    landmarks: [
      "Iglesia de la Trinidad de Gergeti",
      "Casco antiguo de Tiflis",
      "Vardzia (Ciudad Cueva)",
    ],
  },
  xk: {
    description:
      "Kosovo, una joven nación balcánica, rica en historia y magníficos paisajes montañosos, se destaca por sus joyas históricas otomanas bien conservadas y una población muy acogedora.",
    gastronomy: "Flija, burek, qebapa, queso Šar.",
    landmarks: ["Monasterio Visoki Dečani", "Viejo prizren", "Cañón de Rugova"],
  },
  li: {
    description:
      "Liechtenstein, una de las naciones más pequeñas del mundo, se extiende entre Suiza y Austria a lo largo del valle del Rin, dominado por su hermoso castillo principesco y sus picos alpinos.",
    gastronomy: "Käsknöpfle (pasta de queso), Ribel.",
    landmarks: [
      "Castillo de Vaduz",
      "Museo de Bellas Artes (Kunstmuseum)",
      "Estación de esquí Malbun",
    ],
  },
  md: {
    description:
      "Moldavia, el tesoro escondido de Europa del Este, atrae inevitablemente a los entusiastas del enoturismo con sus enormes bodegas subterráneas y sus ancestrales monasterios excavados en la roca.",
    gastronomy: "Mămăligă (polenta), plăcinte (pasteles rellenos), sarmale.",
    landmarks: [
      "Orheiul Vechi (Monasterio Rupestre)",
      "Bodegas Cricova",
      "Bodegas Mileștii Mici",
    ],
  },
  me: {
    description:
      "A pesar de su pequeño tamaño, Montenegro esconde algunos de los paisajes más bellos del mar Adriático. La Bahía de Kotor se encuentra con espectaculares montañas oscuras (las 'montañas negras').",
    gastronomy:
      "Brav u Mlijeku (cordero en leche), cevapi, jamón Njeguši ahumado.",
    landmarks: ["Bahía de Kotor", "Parque Nacional Durmitor", "Sveti Stefan"],
  },
  mk: {
    description:
      "En el corazón de los Balcanes, Macedonia del Norte deslumbra con el increíblemente claro y antiguo lago Ohrid, su herencia ortodoxa y sus parques nacionales preservados.",
    gastronomy: "Tavče gravče (frijoles horneados), ajvar, pastrmajlija.",
    landmarks: ["Lago Ohrid", "Iglesia de San Juan en Kaneo", "Cañón de Matka"],
  },
  sm: {
    description:
      "Encaramado en el monte Titano y completamente sin salida al mar frente a Italia, San Marino reclama el título de república y estado constitucional soberano más antiguo del mundo.",
    gastronomy: "Torta Tre Monti, piadina, frijoles con chicharrón.",
    landmarks: [
      "Las Tres Torres (Guaita, Cesta, Montale)",
      "Basílica de San Marino",
      "Plaza de la Libertad",
    ],
  },
  rs: {
    description:
      "Serbia combina la vibrante vida nocturna de Belgrado a orillas del Danubio, la espectacular fortaleza de Petrovaradin y magníficos monasterios ortodoxos escondidos.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (brandy de frutas).",
    landmarks: [
      "Fortaleza de Belgrado (Kalemegdan)",
      "Fortaleza de Golubac",
      "Templo de San Sava",
    ],
  },
  va: {
    description:
      "El Vaticano, el estado soberano más pequeño del mundo, reside en el corazón de Roma y sirve como sede espiritual de la Iglesia Católica y alberga prodigiosas obras maestras artísticas de Miguel Ángel.",
    gastronomy:
      "Ninguna cocina exclusiva; Ofrece gastronomía tradicional romana.",
    landmarks: ["Basílica de San Pedro", "Capilla Sixtina", "Museos Vaticanos"],
  },
};
